module.exports = __webpack_public_path__ + "img/bbshomepage4.f350d808.png";